import React from 'react';
import PropTypes from 'prop-types';

function Frame() {
  return (
    <svg
      width="522"
      height="435"
      viewBox="0 0 522 435"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.9798 405.602C70.2401 223.023 119.712 143.446 175.252 95.2314C230.791 47.024 312.255 17.7543 489.387 53.4512C408.789 36.8715 336.244 106.477 342.788 196.701C349.328 286.923 364.965 325.73 401.808 407.594L41.9798 405.602Z"
        fill="url(#paint0_linear_685_1489)"
      />
      <path
        d="M49.5897 423.512C108.265 443.625 358.46 431.373 403.706 415.554C442.507 378.183 424.219 280.003 390.379 261.234C376.116 276.086 380.759 276.409 371.34 297.046C371.34 297.046 343.808 236.527 314.223 237.36C284.638 238.193 262.819 308.984 262.819 308.984C249.798 289.432 237.808 270.524 203.798 271.182C169.789 271.842 147.447 298.642 127.643 318.931C127.643 318.931 122.203 275.598 102.893 271.182C83.5833 266.767 49.5843 312.962 49.5843 312.962C47.5341 284.649 32.3949 274.573 15.3148 267.203C-14.5474 305.741 0.514965 398.943 49.5843 423.513L49.5897 423.512Z"
        fill="url(#paint1_linear_685_1489)"
      />
      <path
        d="M521.013 54.5145C521.013 84.6214 497.656 109.029 468.845 109.029C440.035 109.029 416.678 84.6214 416.678 54.5145C416.678 24.4076 440.035 0 468.845 0C497.656 0 521.013 24.4076 521.013 54.5145Z"
        fill="url(#paint2_radial_685_1489)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_685_1489"
          x1="-1.81331"
          y1="323.964"
          x2="459.504"
          y2="130.018"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#800000" />
          <stop offset="1" stopColor="#D40000" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_685_1489"
          x1="219.965"
          y1="264.343"
          x2="219.295"
          y2="413.554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9" />
          <stop offset="1" stopColor="#CCCCCC" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_685_1489"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(468.84 54.5145) scale(52.1677 54.5145)"
        >
          <stop stopColor="#CCCCCC" />
          <stop offset="1" stopColor="#F2F2F2" />
        </radialGradient>
      </defs>
    </svg>
  );
}

Frame.propTypes = {
  color: PropTypes.string,
};

Frame.defaultProps = {
  color: '#000000',
};

export default Frame;
